import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import {
  Alert,
  Box,
  Button,
  Container,
  Grid,
  Link,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';

import EmploymentSubMenu from '@/components/nav/EmploymentSubMenu';
import ComingSoonPopup from '@/components/ui/ComingSoonPopup';
import Hidden from '@/components/ui/TzoHidden';
import VideoPopup from '@/components/VideoPopup';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';
// import type { LayoutWrapperContents } from '@/types/LayoutWrapperContents';

const Form941 = () => {
  const [open, setOpen] = useState(false);
  const [referralUrl, SetReferralUrl] = useState('formulario 941sp');

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading: `Stay on top of your payroll tax responsibilities`,
  //   SubHeading:
  //     '<span style="font-weight:500; color:#333;" >E-file Form 941 Now to save time and reduce stress.</span>',
  //   CtaText: 'E-file Form 941 Now!',
  //   CtaSubHeading: ``,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form941sticky`,
  //   isActive: true,
  // };

  useEffect(() => {
    const isIRSPageReferral = document.referrer === 'https://www.irs.gov/';
    if (isIRSPageReferral) SetReferralUrl('form941irs');
  });

  const [isvideoPopup, setvideoPopup] = useState(false);

  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 7, 31));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 7, 31)
      );
    }, 1000); // Updates every second (adjust if needed)
  }, []);
  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="E-File Formulario 941(sp) para 2026 | File Form 941 online"
          description="E-File Form 941-SP for 2026 using TaxZerone for secure, IRS-authorized e-filing. Easily report quarterly payroll taxes accurately and on time."
          keywords="Form 941-SP, Form 941-SP Online, Payroll Taxes, E-file Form 941-SP"
          canonical="employment-tax/e-file-irs-form-941-sp/"
          jsonLdPricing="6.99"
          jsonLdAggregateRatingValue="5.00"
          jsonLdAggregateRatingCount="54869"
          ogShareImg="assets/images/employment-share-img.png"
        />
      }
    >
      <VideoPopup
        isvideoPopup={isvideoPopup}
        setvideoPopup={setvideoPopup}
        src="https://www.youtube.com/embed/8KUp9tZMNp8?autoplay=1&rel=0"
      />
      {/* <ExitPopup941 /> */}
      {/* isPriceView1099s={false}
        setIsPriceView1099s={function (value: SetStateAction<boolean>): void {
          throw new Error('Function not implemented.');
        }} */}

      <EmploymentSubMenu />
      <ComingSoonPopup open={open} setOpen={setOpen} />
      {/* <Container maxWidth="md">
        <Box sx={{ px: 2, mt: 3, mx: 0 }}>
          <Alert
            severity="warning"
            icon={<WarningIcon sx={{ fontSize: 30 }} />}
            sx={{ borderRadius: 3 }}
          >
            <AlertTitle
              sx={{ fontSize: { xs: 18, sm: 20, md: 22 }, fontWeight: 600 }}
            >
              Attention! Last Day to E-File Forms 941!
            </AlertTitle>

            <Typography
              variant="body1"
              sx={{ fontSize: { xs: 16, sm: 17, md: 18 } }}
            >
              Don&apos;t miss the deadline! Today is the <span style={{ fontWeight: 600 }}>final day</span> to
              electronically file your <span style={{ fontWeight: 600 }}>Form 941</span> (Employer&apos;s
              Quarterly Federal Tax Return).
            </Typography>
          </Alert>
        </Box>
      </Container> */}
      {/* <Stack
        direction={{ xs: 'column', sm: 'row' }}
        alignItems="center"
        justifyContent="center"
        spacing={{ xs: 1, sm: 2 }}
        sx={{
          position: { xs: 'relative', sm: 'sticky' },
          background: 'linear-gradient(135deg, #0a7581, #0d2b2f)',
          p: 1.5,
          px: 2.5,
          color: '#fff',
          minHeight: 40,
          left: 0,
          right: 0,
          zIndex: 11,
          textAlign: 'center',
          top: { xs: 0, sm: 114, md: 118 },
        }}
      >
        <Typography
          variant="h6"
          sx={{
            color: '#cbcbcb',
            lineHeight: 1.3,
            fontSize: { xs: 14, sm: 16, md: 18, lg: 20 },
          }}
        >
          {' '}
          <span style={{ fontWeight: 600, color: '#ecf39e' }}>
            {' '}
            📢 Deadline Has Passed!
          </span>{' '}
          E-file{' '}
          <span style={{ fontWeight: 600, color: '#ffffff' }}>
            Form 941 (Q1-2026)
          </span>{' '}
          Now to Avoid IRS Penalties.
        </Typography>
        <Button
          variant="contained"
          size="small"
          href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form941`}
          sx={{
            backgroundColor: '#fff',
            '&:hover, &:focus': {
              backgroundColor: '#0a7581',
              color: '#fff',
              // backgroundColor: '#213e99',
              // color: '#fff',
            },
            minWidth: 90,

            px: 2,
            py: 0.5,
            color: '#333',
            mt: { xs: 0, md: 0 },
            display: { xs: 'inline-block', sm: 'inline-block' },
            mx: { xs: 'auto', sm: 1 },
            borderRadius: 2,
            boxShadow: 'none',
            fontSize: { xs: 12, sm: 14, md: 16 },
            textTransform: 'none',
          }}
        >
          E-file Now
        </Button>
      </Stack> */}
      <Container
        sx={{
          position: 'relative',
          mt: 2,
          mb: 0,
        }}
        maxWidth="lg"
      >
        <Box
          sx={{
            background: 'linear-gradient(135deg, #0a7581, #0d2b2f)',
            p: 1.5,
            px: 2.5,
            color: '#fff',
          }}
          className="ribbon"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 2 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Typography
              component="div"
              variant="body1"
              sx={{
                textAlign: { xs: 'center', sm: 'left' },
                fontSize: { xs: 15, sm: 17, md: 18, lg: '1.20rem' },
                color: '#efefefd5',
                lineHeight: 1.3,
              }}
            >
              <strong>📢 ¡Ya pasó la fecha límite! </strong> Presenta
              electrónicamente el Formulario 941
              <b style={{ fontWeight: 600, color: '#fcf6bd' }}>
                {' '}
                (2.º trimestre de 2026)
              </b>{' '}
              ahora para minimizar las multas del IRS.
            </Typography>
            <Box>
              {/* <Typography
                variant="body2"
                sx={{
                  textAlign: 'center',
                  mb: { xs: 1, sm: 1 },
                  lineHeight: 1.3,
                }}
              >
                Tiempo restante para presentar la solicitud antes de la fecha
                límite{' '}
                <Hidden smUp>
                  <br />
                </Hidden>
                (
                <span style={{ fontWeight: 600, color: '#fff' }}>
                  Julio 31, 2026
                </span>
                ):
              </Typography> */}
              <Countdown date={lastDayTaxSeason} renderer={renderer} />
            </Box>

            <Box>
              <Button
                variant="contained"
                size="small"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                sx={{
                  backgroundColor: '#fff',
                  '&:hover, &:focus': {
                    backgroundColor: '#0a7581',
                    color: '#fff',
                  },
                  px: 2,
                  color: '#333',
                  mt: { xs: 0, md: 0 },
                  display: { xs: 'inline-block', sm: 'inline-block' },
                  mx: { xs: 'auto', sm: 1 },
                  borderRadius: 3,
                  boxShadow: 'none',
                  fontSize: 18,
                  textTransform: 'none',
                  whiteSpace: 'nowrap',
                }}
              >
                Presentar ahora
              </Button>
            </Box>
          </Stack>
        </Box>
      </Container>
      <Container maxWidth="xl" sx={{ mt: { sm: 3, md: 3 } }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={3}
          sx={{ px: { xs: 2, md: 0 } }}
        >
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'left' },
              alignItems: 'center',
              display: 'flex',
              width: '100%',
              maxWidth: { xs: 'inherit', lg: 770 },
              minWidth: { xs: 'inherit', md: 530 },
              pl: { xs: 0, md: 6, lg: 8, xl: 12 },
              justifyContent: 'center',
            }}
          >
            {/* <Box component={'div'}> */}
            <Box
              sx={{
                mt: { xs: 2, sm: 3, md: 2, lg: 0 },
                mb: { xs: 2, sm: 2, md: 2, lg: 4 },
              }}
            >
              {/* <Typography
                  variant="body1"
                  sx={{
                    textAlign: 'left',
                    mb: { xs: 1, sm: 1.5 },
                    lineHeight: 1.3,
                  }}
                >
                  Time left to file before the deadline(
                  <span style={{ fontWeight: 600 }}>
                    31<sup>st</sup> Jan 2025
                  </span>
                  ):
                </Typography>
                <Countdown date={lastDayTaxSeason} renderer={renderer} />
              </Box> */}
              <Typography
                variant="h1"
                sx={{
                  fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                  fontWeight: 600,
                  color: '#374151',
                  mb: 3,
                }}
              >
                Presenta de manera electrónica el{' '}
                <span className="highlight-container">
                  <span className="highlight">Formulario 941sp</span>
                </span>
                {'  '}
                del IRS para el año fiscal 2026.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  mb: 2,
                }}
              >
                Simplifica tu presentación trimestral con nuestra plataforma de
                presentación electrónica autorizada por el IRS. Transmite tu
                Formulario 941 (sp) en minutos y recibe una confirmación al
                instante. Asegurando cada trimestre envíos rápidos y precisos y
                totalmente en cumplimiento.
              </Typography>
              <Stack
                direction={{ xs: 'column-reverse', md: 'row' }}
                spacing={{ xs: 1, md: 6 }}
                justifyContent={{
                  xs: 'center',
                  md: 'flex-start',
                }}
                alignItems="center"
                sx={{ mt: 4 }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mr: { xs: 0, md: 4 },
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': {
                        transform: 'scale(1.1)',
                      },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                  >
                    File Formulario 941 ahora
                  </Button>
                  {/* <Typography
                    variant="body2"
                    sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                  >
                    Takes 3 steps and less than 5 minutes
                  </Typography> */}
                </Box>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                >
                  <Box
                    sx={{
                      mb: { xs: '0 !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/irs-authorized.webp" />
                      <source srcSet="/assets/images/irs-authorized.png" />
                      <Box
                        component="img"
                        src="/assets/images/irs-authorized.png"
                        loading="lazy"
                        alt="IRS-authorized e-file provider"
                        width={70}
                        height={69}
                        sx={{
                          width: { xs: 50, md: 70 },
                          height: { xs: 49, md: 69 },
                        }}
                      />
                    </picture>
                  </Box>
                  <Box
                    sx={{
                      mb: { xs: '0px !important', md: '0px !important' },
                    }}
                  >
                    <picture>
                      <source srcSet="/assets/images/tzo-soc2.webp" />
                      <source srcSet="/assets/images/tzo-soc2.png" />
                      <Box
                        component="img"
                        src="/assets/images/tzo-soc2.png"
                        loading="lazy"
                        alt="TZO SOC2 Compliant"
                        width={90}
                        height={89}
                        sx={{
                          width: { xs: 70, md: 90 },
                          height: { xs: 69, md: 89 },
                        }}
                      />
                    </picture>
                  </Box>
                </Stack>
              </Stack>
              {/* <Box
                sx={{
                  position: 'relative',
                  maxWidth: 580,
                  mx: { xs: 'auto', md: 0 },
                  mt: 5,
                }}
              >
                <Box
                  sx={{
                    background: '#333',
                    p: 1,
                    px: 2,
                    color: '#fff',
                    '&.ribbon:before': { left: 0 },
                    '&.ribbon:after': { right: 0 },
                  }}
                  className="ribbon"
                >
                  <Box>
                    <Typography
                      variant="body1"
                      sx={{
                        textAlign: { xs: 'center', sm: 'center' },
                        fontSize: { xs: 16, sm: 18, md: 20 },
                      }}
                    >
                      Form 941 for Quarter 1, 2024, is due on{' '}
                      <strong>April 30</strong>
                    </Typography>
                  </Box>
                </Box>
              </Box> */}
            </Box>
          </Box>
          <Hidden mdDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/941sp-landing-img.webp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <source
                  srcSet="/assets/images/941sp-landing-img.png"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
                <img
                  src="/assets/images/941sp-landing-img.png"
                  alt="Formulario 941sp"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Hidden>
          <Hidden mdUp smDown>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'flex-end',
                width: '100%',
                backgroundPosition: 'center center !important',
                mt: '0 !important',
              }}
            >
              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/941-landing-img-sm.webp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <source
                  srcSet="/assets/images/941-landing-img-sm.png"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
                <img
                  src="/assets/images/941-landing-img-sm.png"
                  alt="Formulario 941sp"
                  className="img-responsive-banner"
                  width={440}
                  height={365}
                />
              </picture>
            </Box>
          </Hidden>
        </Stack>
      </Container>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container
          maxWidth="lg"
          sx={{
            my: { xs: 0, md: 3, lg: 5 },
            py: { xs: 2, sm: 3, md: 3, lg: 3 },
            borderRadius: { xs: 0, md: 4 },
            mx: { xs: 0, md: 3, lg: 'auto' },
          }}
          className="gradient-bg"
        >
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 1, sm: 3 }}
            justifyContent="space-around"
            alignItems="center"
          >
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 24, md: 24, sm: 22, xs: 20 },
                  fontWeight: 500,
                  mb: 0,
                  textAlign: 'left',
                  lineHeight: 1.5,
                }}
              >
                Presenta tu Formulario 941(sp) con TaxZerone a un precio
                accesible.
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 16, md: 16, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 0,
                  textAlign: 'left',
                }}
              >
                Completa tus declaraciones trimestrales con confianza, sin
                demora ni complicaciones.
              </Typography>
            </Box>
            <Box
              sx={{
                width: '100%',
                maxWidth: { xs: '100', sm: 250, md: 280 },
                textAlign: 'center',
                fontSize: 18,
                lineHeight: 1.2,
              }}
            >
              E-file for just
              <br />
              <Box
                component="strong"
                sx={{
                  color: '#ffe400',
                  fontSize: { xs: 30, sm: 36, md: 48, lg: 60 },
                }}
              >
                $6.99
              </Box>
              {/* <Typography
                variant="body2"
                sx={{ mt: 0, fontSize: { xs: 11, sm: 14 } }}
              >
                Transparent pricing with no hidden fees
              </Typography> */}
            </Box>
          </Stack>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  ¿Qué es el Formulario 941(sp)?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  El Formulario 941(sp) se utiliza para reportar la Declaración
                  del Impuesto Federal TRIMESTRAL:
                </Typography>
                <Typography
                  component="div"
                  variant="body1"
                  sx={{ mb: 3, color: '#6e6e6e' }}
                >
                  <Box
                    component="ul"
                    sx={{
                      width: '100%',
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                      ml: { xs: 0, sm: 3 },
                      mt: { xs: 0, md: 3 },
                      mb: { xs: 0, md: 3 },
                      '& li': { display: 'flex' },
                    }}
                  >
                    <li
                      style={{
                        marginBottom: 15,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Impuestos federales retenidos de los salarios de los
                        empleados
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 15,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Seguro social e impuestos de gastos médicos FICA
                      </Box>
                    </li>
                    <li
                      style={{
                        marginBottom: 12,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      <Box>
                        Ajustes de pago por enfermedad, propinas, y seguro de
                        vida colectivo a término.
                      </Box>
                    </li>
                  </Box>
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="center">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  mt: { xs: 3, md: 0 },
                  mb: { xs: 3, md: 3 },
                  mr: { xs: 0, md: 0 },
                  maxHeight: 432,
                }}
              >
                <picture>
                  <source srcSet="/assets/images/detalles-del-formulario-941-img.webp" />
                  <source srcSet="/assets/images/detalles-del-formulario-941-img.png" />
                  <img
                    src="/assets/images/detalles-del-formulario-941-img.png"
                    alt="¿Qué es el Formulario 941(sp)"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={500}
                    height={432}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column', md: 'row' } }}
          >
            <Grid size={{ md: 6, xs: 12 }} textAlign="center">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  textAlign: { xs: 'center', md: 'right' },
                  mt: { xs: 3, md: 0 },
                  mb: { xs: 3, md: 3 },
                  mr: { xs: 0, md: 0 },
                  maxHeight: 432,
                }}
              >
                <picture>
                  <source srcSet="/assets/images/941sp-formulario-img.webp" />
                  <source srcSet="/assets/images/941sp-formulario-img.png" />
                  <img
                    src="/assets/images/941sp-formulario-img.png"
                    alt="¿Quién debe llenar el Formulario 941(sp)"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={500}
                    height={432}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mt: { xs: 1, md: 0 }, mb: { xs: 0, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    lineHeight: 1.5,
                    mb: 3,
                  }}
                >
                  ¿Quién debe llenar el Formulario 941(sp)?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  Los patrones de América Latina, Samoa Americana, Guam, la
                  mancomunidad de las Islas Marianas del Norte y las Islas
                  Vírgenes de los Estados Unidos pueden llenar ahora la{' '}
                  <span style={{ fontWeight: 600 }}>Forma 941 (sp)</span> del
                  IRS, o si prefieren hacer sus declaraciones en inglés, pueden
                  utilizar la{' '}
                  <Link
                    href="/employment-tax/e-file-irs-form-941/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Forma 941
                  </Link>
                  .
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  mt: 1,
                  textAlign: 'center',
                }}
              >
                Fecha límite para llenar el Formulario 941(sp) para el año 2026
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                El Formulario 941 (sp) tiene fecha límite en el último día del
                mes correspondiente a cada trimestre.
              </Typography>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 3 }}
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  py: 3,

                  backgroundColor: '#f0f2f9',
                  // backgroundColor: '#0896ba',
                  // boxShadow:
                  //   'rgba(50, 50, 93, 0.25) 10px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px',
                  position: 'relative',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 22, sm: 19, xs: 16 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  er Trimestre 1
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 16, fontWeight: 400, mb: 2 }}
                >
                  (Ene–Mar){' '}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 18, fontWeight: 600 }}
                  // className="new-ribbon-941"
                >
                  Abril 30
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 3 }}
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  py: 3,
                  minHeight: '100%',
                  // backgroundColor: '#f0f2f9',
                  backgroundColor: 'rgb(61, 188, 158)',
                  color: '#fff',
                  position: 'relative',
                  boxShadow:
                    'rgba(50, 50, 93, 0.25) 10px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 22, sm: 19, xs: 16 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  2do Trimestre
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 16, fontWeight: 600, mb: 2 }}
                >
                  (Abr–Jun)
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 18, fontWeight: 600 }}
                  className="new-ribbon-941"
                >
                  Julio 31
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 3 }}
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  py: 3,
                  position: 'relative',
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 22, sm: 19, xs: 16 },
                    fontWeight: 600,
                    mb: 1,
                  }}
                >
                  3er Trimestre
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 16, fontWeight: 400, mb: 2 }}
                >
                   (Jul–Sep)
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 18, fontWeight: 600 }}
                >
                  Noviembre 2
                </Typography>
              </Paper>
            </Grid>
            <Grid
              size={{ xs: 12, sm: 6, md: 3 }}
              sx={{ justifyContent: 'center', alignItems: 'center' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 2,
                  borderRadius: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  py: 3,
                  backgroundColor: '#f0f2f9',

                  // backgroundColor: 'rgb(207, 147, 84, 0.95)',
                  // boxShadow:
                  //   'rgba(50, 50, 93, 0.25) 10px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px',
                  // position: 'relative',
                  minHeight: '100%',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 22, sm: 19, xs: 16 },
                    fontWeight: 600,
                    mb: 1,
                    // color: '#fff',
                  }}
                >
                  4to Trimestre
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: 16,
                    // fontWeight: 600,
                    mb: 2,
                    // color: '#efefefff',
                  }}
                >
                  (Oct–Dec)
                </Typography>
                <Typography
                  variant="body1"
                  sx={{ fontSize: 18, fontWeight: 600 }}
                >
                  Febrero 1
                </Typography>
              </Paper>
            </Grid>
            <Grid size={12} sx={{ textAlign: 'center', mt: 2 }}>
              <Box sx={{ maxWidth: 950, width: '100%', margin: 'auto' }}>
                <Alert
                  severity="warning"
                  id="semi"
                  icon={false}
                  sx={{
                    fontSize: 13,
                    mt: 3,
                    mb: 3,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Nota :</span> Si depositas
                  todos los impuestos de nómina a tiempo y en su totalidad,
                  tienes 10 días adicionales para llenar el Formulario 941(sp).
                </Alert>
                <Box>
                  {' '}
                  <Button
                    variant="contained"
                    className="btn-primary"
                    sx={{
                      mt: 2,
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                  >
                    E-file 941 ahora
                  </Button>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                ¿Cómo presentar en línea el Formulario 941(sp) de IRS con
                TaxZerone?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Completa tu declaración en tan solo 3 simples pasos.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="lg" sx={{ mb: { xs: 6, sm: 8, md: 10 } }}>
          {/* <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component={'div'}
              sx={{
                display: 'flex',
                justifyContent: { xs: 'center', md: 'flex-end' },
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: 3,
              }}
            >
              <Box
                component={'iframe'}
                title="What is Form 2290: A Comprehensive Guide"
                src="https://www.youtube.com/embed/8KUp9tZMNp8?&rel=0"
                sx={{
                  width: { xs: '100%', sm: 500 },
                  height: { xs: '100%', sm: 281 },
                  border: '10px solid #333 !important',
                  borderRadius: 5,
                }}
                allowFullScreen={true}
              />
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter or Upload your Data"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter or Upload your Data
                    </Typography>
                    <Typography variant="body1">
                      Manually enter your payroll details or import them in bulk
                      using our Excel template
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-2-icon.webp" />
                        <source srcSet="/assets/images/step-2-icon.png" />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Pay Any Due Amount and Sign"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Pay Any Due Amount and Sign
                    </Typography>
                    <Typography variant="body1">
                      Choose your preferred payment method to pay the balance
                      due and e-sign the return.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
                <TimelineItem>
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/step-3-icon.webp" />
                        <source srcSet="/assets/images/step-3-icon.png" />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Transmit the Return to the IRS"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Transmit the return to the IRS
                    </Typography>
                    <Typography variant="body1">
                      Securely submit your return to the IRS and get notified
                      when it&apos;s accepted.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
            </Box>
          </Stack> */}
          <Grid container spacing={2} justifyContent="center">
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  borderRadius: 5,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box sx={{ mb: 2 }}>
                  <picture>
                    <source srcSet="/assets/images/step-1-icon.webp" />
                    <source srcSet="/assets/images/step-1-icon.png" />
                    <img
                      src="/assets/images/step-1-icon.png"
                      alt="Enter or Upload your Data"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box sx={{ textAlign: 'center' }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 600,
                      mb: 2,
                    }}
                  >
                    Ingresa los datos de tu negocio
                  </Typography>{' '}
                  <Typography variant="body1">
                    Introduce la información requerida como el nombre de la
                    empresa, los salarios de los empleados, las retenciones de
                    impuestos y depósitos.
                  </Typography>{' '}
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  borderRadius: 5,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box sx={{ mb: 2 }}>
                  <picture>
                    <source srcSet="/assets/images/step-2-icon.webp" />
                    <source srcSet="/assets/images/step-2-icon.png" />
                    <img
                      src="/assets/images/step-2-icon.png"
                      alt="Pay Any Due Amount and Sign"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 600,
                      mb: 2,
                    }}
                  >
                    Paga tus impuestos adeudados y firma.
                  </Typography>{' '}
                  <Typography variant="body1">
                    Selecciona el método de pago que más te convenga para pagar
                    tus impuestos adeudados y firma tu Formulario electrónico.
                  </Typography>{' '}
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  borderRadius: 5,
                  textAlign: 'center',
                  minHeight: '100%',
                }}
              >
                <Box sx={{ mb: 2 }}>
                  <picture>
                    <source srcSet="/assets/images/step-3-icon.webp" />
                    <source srcSet="/assets/images/step-3-icon.png" />
                    <img
                      src="/assets/images/step-3-icon.png"
                      alt="Transmit the return to the IRS"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Box>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { md: 20, sm: 18, xs: 16 },
                      fontWeight: 600,
                      mb: 2,
                    }}
                  >
                    Revisa y transmite al IRS
                  </Typography>{' '}
                  <Typography variant="body1">
                    Revisa y envía tu Formulario 941 al IRS y recibe una
                    confirmación una vez que tu Formulario haya sido aceptado
                    correctamente.
                  </Typography>{' '}
                </Box>
              </Paper>
            </Grid>
          </Grid>
          <Box sx={{ textAlign: { xs: 'center', md: 'center' } }}>
            <Typography
              variant="body1"
              sx={{ mt: 3, mb: 1, fontSize: { md: 18, sm: 16, xs: 16 } }}
            >
              ¿Listo para presentar en línea tu Formulario 941 (sp)? Empieza
              ahora y recibe rápido tu aceptación del IRS
            </Typography>
            <Stack
              spacing={2}
              direction="row"
              sx={{
                textAlign: 'center',
                justifyContent: 'center',
                alignContent: 'center',
                display: 'grid',
                gridTemplateColumns: 'auto auto ',
                mt: 4,
              }}
            >
              <Button
                variant="contained"
                sx={{
                  mt: 0,
                  transition: 'all 0.3s ease 0s',
                  '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                }}
                className="btn-primary"
                href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
              >
                Presenta 941 ahora en línea
              </Button>
              {/* <Button
                onClick={openPopup}
                sx={{ ml: 2 }}
                className="icon-blink"
                aria-label="video"
              >
                <Box
                  component="img"
                  src="/assets/images/youtube-icon.svg"
                  width={60}
                  height={67}
                  loading="lazy"
                  sx={{}}
                  alt="youtube video"
                />
              </Button> */}
            </Stack>
          </Box>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ mb: 2 }}>
          <Grid
            container
            spacing={2}
            sx={{ my: 5 }}
            direction={{ xs: 'column', md: 'row' }}
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  mt: 1,
                  lineHeight: 1.5,
                  textAlign: 'center',
                }}
              >
                ¿Qué información requieres para completar tu <br />
                Formulario 941 (sp)?
              </Typography>
              <Typography variant="body1" sx={{ textAlign: 'center', mb: 1 }}>
                Ten la información a la mano y completa tu formulario en minutos
                con TaxZerone.
              </Typography>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="center">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '90%',
                  textAlign: { xs: 'center', md: 'right' },
                  mt: { xs: 3, md: 0 },
                  mb: { xs: 3, md: 0 },
                  mr: { xs: 0, md: 0 },
                }}
              >
                <picture>
                  <source srcSet="/assets/images/form-941-sp-information-need-complete-img.webp" />
                  <source srcSet="/assets/images/form-941-sp-information-need-complete-img.png" />
                  <img
                    src="/assets/images/form-941-sp-information-need-complete-img.png"
                    alt="¿Qué información requieres para completar tu Formulario 941 (sp)"
                    loading="lazy"
                    className="img-responsive-banner"
                    width={700}
                    height={817}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
              }}
            >
              <Box
                sx={{
                  p: { xs: 2, md: 2 },
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    textAlign: 'left',
                    fontWeight: 600,
                    lineHeight: 1.5,
                    mb: 1,
                  }}
                >
                  1. Datos del negocio
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    pl: 5,
                    m: 0,
                    color: '#4b5563',
                    lineHeight: 2,
                    '& li': {
                      mb: 1,
                    },
                  }}
                >
                  <li>Nombre</li>
                  <li>EIN</li>
                  <li>Dirección</li>
                  <li>Detalles del trimestre (Q1/Q2/Q3/Q4)</li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    textAlign: 'left',
                    fontWeight: 600,
                    lineHeight: 1.5,
                    mb: 1,
                  }}
                >
                  2. Información del empleo e impuestos
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    pl: 5,
                    m: 0,
                    color: '#4b5563',
                    lineHeight: 2,
                    '& li': {
                      mb: 1,
                    },
                  }}
                >
                  <li>Conteo de empleados y salarios </li>
                  <li>Impuesto Federal sobre la Renta de los salarios </li>
                  <li>Salarios y propinas sujetos a FICA </li>
                  <li>
                    Total de depósitos de impuestos federales durante el
                    trimestre.
                  </li>
                  <li>Pago en exceso o adeudo</li>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { md: 24, sm: 20, xs: 18 },
                    textAlign: 'left',
                    fontWeight: 600,
                    lineHeight: 1.5,
                    mb: 1,
                  }}
                >
                  3. Firma & Autorización
                </Typography>
                <Box
                  component="ul"
                  sx={{
                    pl: 5,
                    m: 0,
                    color: '#4b5563',
                    lineHeight: 2,
                    '& li': {
                      mb: 1,
                    },
                  }}
                >
                  <li>Nombre y cargo del firmante</li>
                  <li>
                    <Link
                      href="/employment-tax/e-file-irs-form-94x-pin-request/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      94x online signature PIN
                    </Link>{' '}
                    or{' '}
                    <Link
                      href="/resources/employment-tax/form-941-signature-options//"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 8453-EMP
                    </Link>{' '}
                  </li>
                </Box>
                <Alert
                  severity="warning"
                  id="semi"
                  icon={false}
                  sx={{
                    fontSize: 13,
                    mt: 1,
                    mb: 1,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Nota :</span> Puedes
                  solicitar tu PIN 94-X sin costo alguno utilizando TaxZerone.
                </Alert>
                {/* BUTTON */}
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, md: 6 }}
                  justifyContent={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  alignItems="center"
                  sx={{ mt: 4 }}
                >
                  <Box
                    sx={{
                      textAlign: 'center',
                      mr: { xs: 0, md: 4 },
                      mb: { xs: 2, sm: 0 },
                    }}
                  >
                    <Button
                      variant="contained"
                      className="btn-primary"
                      sx={{
                        transition: 'all 0.3s ease 0s',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.1)',
                        },
                      }}
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
                    >
                      E-file 941 ahora
                    </Button>
                  </Box>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Container maxWidth="md">
          <TableContainer
            sx={{
              border: '2px solid #000',
              borderRadius: 4,
              boxShadow: '0 0 30px rgba(0, 0, 0, .35)',
            }}
          >
            <Table
              sx={{
                '& tr th': {
                  fontSize: 18,
                  borderBottom: '1px solid #000',
                  color: '#ccc',
                },

                '& tr td': {
                  backgroundColor: '#ccc',
                  fontSize: 16,
                  py: 1.2,
                  borderBottom: '1px solid #000',
                },

                '& tr td:nth-of-type(2)': {
                  borderLeft: '1px solid #000',
                },

                '& tr:nth-child(even) td': {
                  backgroundColor: '#fff',
                },

                '& tr:last-child td': {
                  borderBottom: 'none',
                },
              }}
            >
              <TableHead>
                <TableRow sx={{ backgroundColor: '#333' }}>
                  <TableCell colSpan={2} align="center">
                    Errores más comunes con el Formulario 941(sp)
                  </TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow>
                  <TableCell>
                    ❌ Seleccionar el trimestre o año equivocado
                  </TableCell>

                  <TableCell>
                    ❌ Registro incorrecto de los depósitos de impuestos
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>❌ EIN o nombre del negocio incorrectos</TableCell>

                  <TableCell>
                    ❌ Olvidar añadir el anexo B (cuando se requiere)
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    ❌ Errores en el cálculo de salarios e impuestos
                  </TableCell>

                  <TableCell>❌ No firmar la declaración</TableCell>
                </TableRow>

                <TableRow>
                  <TableCell>
                    ❌ Depósitos no conciliados con la obligación tributaria
                  </TableCell>

                  <TableCell>❌ No reportar salarios en ceros</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  lineHeight: 1.5,
                  textAlign: 'center',
                }}
              >
                ¿Por qué escoger TaxZerone para completar el <br />
                Formulario 941(sp)?
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone hace que sea sencillo llenar el{' '}
                <span style={{ fontWeight: 600 }}>Formulario 941 (SP)</span>{' '}
                para los patrones que prefieren <br />
                formatos en español. Aquí te explicamos por qué las empresas
                confían en TaxZerone:
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={2}
            m={2}
            mt={4}
            pb={{ xs: 0, sm: 4, md: 7 }}
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS-authorized"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Autorizado por IRS
                </Typography>
                <Typography variant="body1">
                  Utiliza <span style={{ fontWeight: 600 }}>TaxZerone</span> una
                  solución segura y confiable para declarar tus impuestos con el
                  IRS
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/smart-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/smart-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/smart-icon.png"
                      alt="Easy Zero Filing "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Admite declaraciones en cero
                </Typography>
                <Typography variant="body1">
                  ¿No tienes impuestos de nómina este trimestre? Selecciona{' '}
                  <span style={{ fontWeight: 600 }}>
                    “Sin impuestos que reportar”
                  </span>{' '}
                  y presenta tu formulario 941 (SP) al IRS en un instante.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/agent-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/agent-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/agent-icon.png"
                      alt="Bulk Upload "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Asistencia en pantalla
                </Typography>
                <Typography variant="body1">
                  Nuestras indicaciones en pantalla te guiarán en cada paso,
                  ayudándote a completar la presentación de manera sencilla.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/sign-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/sign-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/sign-icon.png"
                      alt="Smart Calculations "
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Opciones sencillas de firma electrónica
                </Typography>
                <Typography variant="body1">
                  Realiza tu firma electrónica utilizando el PIN de firma
                  electrónica del IRS o el Formulario 8453-EMP.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt="Authorize/Sign your Return"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Actualizaciones instantáneas del estado de tu declaración con
                  el IRS
                </Typography>
                <Typography variant="body1">
                  Recibe actualizaciones en tiempo real una vez que tu
                  declaración haya sido aceptada por el IRS.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/multiple-pay-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/multiple-pay-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/multiple-pay-icon.png"
                      alt="Lowest price"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Múltiples opciones de pago
                </Typography>
                <Typography variant="body1">
                  Puedes pagar los impuestos adeudados utilizando{' '}
                  <Link
                    href="/resources/electronic-funds-withdrawal-efw/"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    EFW
                  </Link>
                  ,{' '}
                  <Link href="/resources/eftps/" sx={{ color: '#0202ff' }}>
                    {' '}
                    EFTPS
                  </Link>
                  , tarjeta de débito o crédito, o giro postal.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-access-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-access-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-access-icon.png"
                      alt="Supports Schedule B & Form 8974"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Contamos con el Formulario 941-X
                </Typography>
                <Typography variant="body1">
                  Corrige errores de tus declaraciones previas 941 (SP) de
                  manera rápida y precisa utilizando TaxZerone.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/form-access-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/form-access-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/form-access-icon.png"
                      alt="Flexible Payment Options"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Contamos con el Anexo B & Formulario 8974
                </Typography>
                <Typography variant="body1">
                  TaxZerone admite el{' '}
                  <span style={{ fontWeight: 600 }}>Anexo B</span> para
                  depositantes quincenales y el{' '}
                  <span style={{ fontWeight: 600 }}>Formulario 8974</span> para
                  créditos de investigación calificados.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  minHeight: '100%',
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  mt: { xs: 0, md: 4 },
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Expert Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Soporte especializado
                </Typography>
                <Typography variant="body1">
                  Nuestro equipo experto te guiará por teléfono, email y chat en
                  español o inglés.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
          {/* <Box sx={{ textAlign: { xs: 'center', md: 'center' }, mb: 5 }}>
            <Button
              variant="contained"
              sx={{
                mt: 4,
                transition: 'all 0.3s ease 0s',
                '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
              }}
              className="btn-primary"
              href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
            >
              E-file Form 941 Now
            </Button>
          </Box> */}
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={7}
            mb={7}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column-reverse', md: 'row' } }}
          >
            <Grid
              size={12}
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  lineHeight: 1.5,
                  mb: 3,
                }}
              >
                ¿Por qué los empleadores escogen TaxZerone para la declaración
                electrónica del Formulario 941(SP)?
              </Typography>

              <Box component="div" sx={{ mb: 4, maxWidth: 900, m: 'auto' }}>
                <TableContainer sx={{ border: '1px solid #828282' }}>
                  <Table aria-label="Comparación TaxZerone">
                    <TableHead>
                      <TableRow
                        sx={{ backgroundColor: '#ccc', fontWeight: 600 }}
                      >
                        <TableCell
                          sx={{
                            color: '#444',
                            width: 300,
                            fontWeight: 600,
                            fontSize: { md: 18, sm: 16, xs: 16 },
                          }}
                        >
                          Función
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            width: 300,
                            fontWeight: 600,
                            fontSize: { md: 18, sm: 16, xs: 16 },
                          }}
                        >
                          TaxZerone <br />
                          <span style={{ fontWeight: 400 }}>
                            (LA MEJOR OPCIÓN)
                          </span>
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            width: 300,
                            fontWeight: 600,
                            fontSize: { md: 18, sm: 16, xs: 16 },
                          }}
                        >
                          Otras plataformas E-file
                        </TableCell>

                        <TableCell
                          sx={{
                            color: '#444',
                            width: 300,
                            fontWeight: 600,
                            fontSize: { md: 18, sm: 16, xs: 16 },
                          }}
                        >
                          Declaración manual (Papel)
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      <TableRow sx={{ backgroundColor: '#fff' }}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Autorizado por el IRS
                        </TableCell>

                        <TableCell>✅ Sí</TableCell>
                        <TableCell>✅ Sí</TableCell>
                        <TableCell>❌ No</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Detección de errores en tiempo real
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ Antes de presentar la declaración se verifican los
                          datos conforme a la información del IRS.
                        </TableCell>

                        <TableCell>Limitado</TableCell>
                        <TableCell>Susceptible a errores</TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#fff' }}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Carga masiva
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ Se importa mediante plantilla de Excel
                        </TableCell>

                        <TableCell>Costo adicional</TableCell>
                        <TableCell>No aplica</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Tiempo de procesamiento
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ Envío instantáneo al IRS
                        </TableCell>

                        <TableCell>1–2 días</TableCell>
                        <TableCell>3–6 semanas</TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#fff' }}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Formulario 8879-EMP <br />
                          (or) <br />
                          Formulario 8453-EMP <br />
                          (or) <br />
                          94x Opción de firma
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ Incluido, sin costo extra
                        </TableCell>

                        <TableCell>⚠️ Costo extra</TableCell>
                        <TableCell>❌ Firma Manual</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Reenvío gratuito <br />
                          <span style={{ fontWeight: 400 }}>
                            (si es rechazado)
                          </span>
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ Sí
                        </TableCell>

                        <TableCell>❌ No</TableCell>
                        <TableCell>❌ No</TableCell>
                      </TableRow>

                      <TableRow sx={{ backgroundColor: '#fff' }}>
                        <TableCell
                          sx={{
                            fontSize: { md: 16, sm: 16, xs: 16 },
                            fontWeight: 600,
                          }}
                        >
                          Soporte al cliente
                        </TableCell>

                        <TableCell
                          sx={{
                            textAlign: 'left',
                            justifyContent: 'center',
                          }}
                        >
                          ✅ Español & Inglés
                        </TableCell>

                        <TableCell>Soporte limitado</TableCell>
                        <TableCell>❌ No</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
            <Grid size={12} sx={{ textAlign: 'center', mt: 2 }}>
              <Box sx={{ maxWidth: 950, width: '100%', margin: 'auto' }}>
                <Alert
                  severity="warning"
                  id="semi"
                  icon={false}
                  sx={{
                    fontSize: 14,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                  }}
                >
                  <span style={{ fontWeight: 600 }}>Nota :</span> Elije
                  TaxZerone para completar el Formulario Form 941 (sp). No te
                  conformes con alternativas obsoletas o caras.
                </Alert>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          background: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Stack
                direction="row"
                spacing={1}
                sx={{ mb: 2 }}
                justifyContent={{ xs: 'center', md: 'center' }}
              >
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-1"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-2"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-3"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-4"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-5"
                />
              </Stack>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  lineHeight: 1.5,
                  mb: { xs: 1, sm: 1 },
                }}
              >
                Descubre por qué los negocios confían en TaxZerone para declarar
                el formulario 941 (SP) de forma rápida y precisa.
              </Typography>

              <Grid
                container
                spacing={2}
                m={0}
                justifyContent="center"
                direction="row"
                className="MuiGrid-root-width"
                sx={{ mb: 3 }}
              >
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#f0f2f9',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        Presente mi formulario 941 (SP) rápido y sin ninguna
                        confusión. Gracias, TaxZerone.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      - Carlos Ramirez
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#f0f2f9',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        Estoy muy satisfecho con el sistema, es fácil de usar y
                        accesible para los dueños de negocios.
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      -Maria Torres
                    </Typography>
                  </Paper>
                </Grid>
                <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                  <Paper
                    elevation={0}
                    sx={{
                      background: '#f0f2f9',
                      p: 2,
                      borderRadius: 3,
                      minHeight: '100%',
                    }}
                  >
                    <Stack
                      direction="row"
                      spacing={1}
                      sx={{ my: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &ldquo;
                      </Typography>
                      <Typography
                        component="div"
                        variant="body1"
                        color="gray"
                        sx={{
                          fontSize: { xs: 16, sm: 18, md: 20 },
                          fontFamily: 'san-serif',
                          fontStyle: 'italic',
                          color: '#414042',
                          lineHeight: 1.2,
                        }}
                      >
                        Excelente producto y muy amigable. ¡Se los recomiendo!
                        <Stack
                          direction="row"
                          spacing={1}
                          sx={{ mt: 2 }}
                          justifyContent={{ xs: 'center', md: 'center' }}
                        >
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-1"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-2"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-3"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-4"
                          />
                          <img
                            src="/assets/images/star-icon.svg"
                            width={18}
                            height={17}
                            alt="star-5"
                          />
                        </Stack>
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontFamily: 'san-serif',
                          fontSize: { xs: 45, sm: 65 },
                          fontWeight: 600,
                          lineHeight: { xs: '30px', sm: '65px' },
                          color: '#999',
                        }}
                      >
                        &rdquo;
                      </Typography>
                    </Stack>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, textAlign: 'right' }}
                    >
                      -Javier Morales
                    </Typography>
                  </Paper>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          background: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { xs: 1, sm: 1 },
                }}
              >
                Formularios complementarios
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Link
                href="/resources/employment-tax/form-941-schedule-b-filing-requirements/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    py: 2,
                    textAlign: 'center',
                    borderWidth: 2,
                    borderColor: 'transparent',
                    transition: 'all 0.3s ease 0s',
                    borderRadius: 5,
                    height: '100%',
                    backgroundColor: '#fff',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.05)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                      fontWeight: 600,
                      my: 3,
                      textAlign: 'center',
                    }}
                  >
                    Formulario ​941 Anexo B
                  </Typography>
                  <Typography variant="body1">
                    Reporta la obligación tributaria para depósitos quincenales.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Link
                href="/resources/employment-tax/form-8974-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    py: 2,
                    textAlign: 'center',
                    borderWidth: 2,
                    borderColor: 'transparent',
                    borderRadius: 5,
                    height: '100%',
                    backgroundColor: '#fff',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.05)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 18, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                      textAlign: 'center',
                    }}
                  >
                    Formulario ​​8974
                  </Typography>
                  <Typography variant="body1">
                    Solicita el crédito fiscal sobre nómina para pequeñas
                    empresas calificadas por el incremento de actividades de
                    investigación.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Link
                href="/resources/employment-tax/form-941-schedule-r/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    py: 2,
                    textAlign: 'center',
                    borderWidth: 2,
                    borderColor: 'transparent',
                    borderRadius: 5,
                    height: '100%',

                    backgroundColor: '#fff',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.05)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 18, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                      textAlign: 'center',
                    }}
                  >
                    Formulario ​​941 Anexo R
                  </Typography>
                  <Typography variant="body1">
                    Asigna el crédito por pagos de asistencia para primas de
                    COBRA.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Link
                href="/resources/employment-tax/form-941-x-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    p: 3,
                    py: 2,
                    textAlign: 'center',
                    borderWidth: 2,
                    borderColor: 'transparent',
                    borderRadius: 5,
                    height: '100%',
                    backgroundColor: '#fff',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.05)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 18, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 3,
                      textAlign: 'center',
                    }}
                  >
                    Formulario ​​941-X
                  </Typography>
                  <Typography variant="body1">
                    Corrige errores en el formulario 941 previamente presentado.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          width: '100% !important',
          mb: 0,
          p: 2,
          textAlign: 'center',
        }}
        m={2}
        mt={0}
        className="curve-bg"
      >
        <Typography
          variant="h2"
          color="white"
          sx={{
            fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
            fontWeight: 600,
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          ¿Listo para simplificar tus impuestos de nómina?
        </Typography>

        <Typography
          variant="body1"
          sx={{
            fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
            fontWeight: 400,
            color: '#f3f3f3',
            mb: 3,
            lineHeight: 1.5,
          }}
        >
          ¡Completa hoy el Formulario 941 (SP) rápido y de forma segura con
          TaxZerone!
        </Typography>
        <Box component="div" sx={{ margin: 'auto' }}>
          <Button
            variant="contained"
            sx={{
              mt: { xs: 0, sm: 4 },
              mb: { xs: 0, md: 0 },
              color: '#444',
              transition: 'all 0.3s ease 0s',
              '&:hover, &active': {
                backgroundColor: '#213e99 !important',
                color: '#fff',
                transform: 'scale(1.1)',
              },
            }}
            className="btn-secondary-white"
            href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=${referralUrl}`}
          >
            Empieza ahora
          </Button>
          {/* <Typography
              variant="body2"
              sx={{ mt: 1, mb: { xs: 2, md: 0 } }}
              color="#dfeae1"
            >
              Simple. Secure. Accurate.
            </Typography> */}
        </Box>
      </Box>
      <Container maxWidth="lg">
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid size={12}>
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                mt: 1,
                textAlign: 'center',
              }}
            >
              Recursos útiles para declarar los impuestos trimestralmente
            </Typography>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Link
              href="/resources/employment-tax/form-941-instructions/"
              sx={{ textDecoration: 'none' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  p: 0,
                  py: 0,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                  transition: 'all 0.3s ease 0s',
                  '&:hover': {
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    transform: 'scale(1.05)',
                  },
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mb: 0,
                    borderTopRightRadius: 12,
                    borderTopLeftRadius: 12,
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/f941-instrucciones-img.webp" />
                    <source srcSet="/assets/images/f941-instrucciones-img.png" />
                    <img
                      src="/assets/images/f941-instrucciones-img.png"
                      alt="Instrucciones Formulario"
                      className="partner-card"
                      loading="lazy"
                      width={361}
                      height={292}
                      style={{
                        borderTopRightRadius: 12,
                        borderTopLeftRadius: 12,
                      }}
                    />
                  </picture>
                </Box>
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                      textAlign: 'center',
                    }}
                  >
                    Instrucciones Formulario
                  </Typography>
                  <Typography variant="body1">
                    941 Sigue las instrucciones en inglés paso a paso del
                    Formulario 941 para presentar tu formulario correctamente.
                  </Typography>
                </Box>
              </Paper>
            </Link>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Link
              href="/resources/employment-tax/form-941-filing-deadlines-and-penalties-guide/"
              sx={{ textDecoration: 'none' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                  transition: 'all 0.3s ease 0s',
                  '&:hover': {
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    transform: 'scale(1.05)',
                  },
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mb: 0,
                    borderTopRightRadius: 12,
                    borderTopLeftRadius: 12,
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/f941-due-date-img.webp" />
                    <source srcSet="/assets/images/f941-due-date-img.png" />
                    <img
                      src="/assets/images/f941-due-date-img.png"
                      alt="Fecha límite para Formulario 941"
                      className="partner-card"
                      loading="lazy"
                      width={361}
                      height={292}
                      style={{
                        borderTopRightRadius: 12,
                        borderTopLeftRadius: 12,
                      }}
                    />
                  </picture>
                </Box>
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                      textAlign: 'center',
                    }}
                  >
                    Fecha límite para <br />
                    Formulario 941
                  </Typography>
                  <Typography variant="body1">
                    Infórmate sobre las fechas límite del Formulario 941 y
                    presenta puntualmente para evitar penalizaciones.
                  </Typography>
                </Box>
              </Paper>
            </Link>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4 }}>
            <Link
              href="/resources/employment-tax/form-941-mailing-address/"
              sx={{ textDecoration: 'none' }}
            >
              <Paper
                variant="outlined"
                sx={{
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',

                  backgroundColor: '#f0f2f9',
                  transition: 'all 0.3s ease 0s',
                  '&:hover': {
                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                    transform: 'scale(1.05)',
                  },
                }}
              >
                <Box
                  sx={{
                    textAlign: 'center',
                    mb: 0,
                    borderTopRightRadius: 12,
                    borderTopLeftRadius: 12,
                  }}
                >
                  <picture>
                    <source srcSet="/assets/images/f941-correo-agregar-img.webp" />
                    <source srcSet="/assets/images/f941-correo-agregar-img.png" />
                    <img
                      src="/assets/images/f941-correo-agregar-img.png"
                      alt="Dirección de envío del Formulario 941"
                      className="partner-card"
                      loading="lazy"
                      width={361}
                      height={292}
                      style={{
                        borderTopRightRadius: 12,
                        borderTopLeftRadius: 12,
                      }}
                    />
                  </picture>
                </Box>
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h3"
                    sx={{
                      fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                      fontWeight: 600,
                      my: 1,
                      textAlign: 'center',
                    }}
                  >
                    Dirección de envío del Formulario 941
                  </Typography>
                  <Typography variant="body1">
                    Consulta la dirección de envío para el 2026 y envía el
                    formulario según tu ubicación.
                  </Typography>
                </Box>
              </Paper>
            </Link>
          </Grid>

          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
            sx={{ borderTop: ' 1px solid rgba(143, 156, 169, 0.24)', mt: 8 }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mt: 4,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Preguntas Frecuentes
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. ¿Para qué se utiliza el Formulario 941-SP del IRS?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box component="div" itemProp="text">
                    <Typography variant="body1" sx={{ mt: 1 }}>
                      El Formulario 941-SP se utiliza para que los empleadores
                      en Puerto Rico reporten al Internal Revenue Service (IRS)
                      los salarios pagados a sus empleados y los impuestos
                      federales retenidos durante cada trimestre. Esto incluye
                      el impuesto federal sobre los ingresos retenido, así como
                      los impuestos del Seguro Social y Medicare. También sirve
                      para calcular e informar la obligación tributaria
                      relacionada con la nómina y asegurar que el empleador
                      cumpla con los requisitos federales de presentación y pago
                      trimestral establecidos por el IRS.
                    </Typography>
                  </Box>
                </Box>
              </Box>
              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. ¿Cuál es la fecha límite para presentar el Formulario
                  941-SP del IRS?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography component="div" itemProp="text">
                    El Formulario 941-SP debe presentarse al Internal Revenue
                    Service (IRS) cada trimestre. La fecha límite generalmente
                    es el{' '}
                    <span style={{ fontWeight: 600 }}>
                      último día del mes siguiente al cierre de cada trimestre.
                    </span>{' '}
                    Si la fecha cae en fin de semana o día feriado federal, el
                    vencimiento se traslada al siguiente día hábil.
                    <Box component="div" sx={{ mb: 0, mt: 2 }}>
                      <TableContainer sx={{ border: '1px solid #828282' }}>
                        <Table aria-label="Due Date Chart">
                          <TableHead>
                            <TableRow sx={{ backgroundColor: '#ccc' }}>
                              <TableCell sx={{ color: '#444', width: 300 }}>
                                Trimestre
                              </TableCell>

                              <TableCell sx={{ color: '#444', width: 300 }}>
                                Meses cubiertos
                              </TableCell>

                              <TableCell sx={{ color: '#444', width: 300 }}>
                                Fecha de vencimiento *
                              </TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            <TableRow>
                              <TableCell>1st Trimestre</TableCell>
                              <TableCell>Enero - Marzo</TableCell>
                              <TableCell>Abril 30</TableCell>
                            </TableRow>

                            <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                              <TableCell>2nd Trimestre</TableCell>
                              <TableCell>Abril - Junio</TableCell>
                              <TableCell>Julio 31</TableCell>
                            </TableRow>

                            <TableRow>
                              <TableCell>3er Trimestre</TableCell>
                              <TableCell>Julio - Septiembre</TableCell>
                              <TableCell>Octubre 31</TableCell>
                            </TableRow>

                            <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                              <TableCell>4to Trimestre</TableCell>
                              <TableCell>Octubre - Diciembre</TableCell>
                              <TableCell>Enero 31</TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        *Si la fecha límite cae en día feriado, puente o fin de
                        semana, se considerará el día siguiente.
                      </Typography>
                    </Box>
                  </Typography>
                </Box>
              </Box>

              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. ¿Hay diferencia entre los dos formularios 941 (SP) y 941?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      No, el Formulario 941 (SP) tiene la misma información y
                      sigue las mismas reglas del IRS que el Formulario 941.
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. ¿Dónde puedo descargar el Formulario 941 SP en español?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Box itemProp="text">
                    <Typography component="div" sx={{ mt: 1 }}>
                      Puedes descargar el Formulario Oficial del IRS{' '}
                      <span style={{ fontWeight: 600 }}>941 (SP)</span>{' '}
                      <Link
                        href="https://www.irs.gov/pub/irs-pdf/f941sp.pdf"
                        sx={{ color: '#0202ff' }}
                      >
                        {' '}
                        PDF
                      </Link>{' '}
                      — en versión español of the{' '}
                      <span style={{ fontWeight: 600 }}>
                        Employer’s Quarterly Federal Tax Return
                      </span>{' '}
                      — directamente de la página del Servicio de Impuestos
                      Interno IRS.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                sx={{
                  borderWidth: 2,
                  borderRadius: 3,
                  textTransform: 'none',
                  '&:hover, &:focus, &:active': { borderWidth: 2 },
                }}
                href="/faqs/form-941/"
              >
                More FAQs
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form941;
